// v5 UIMessage tool parts use `type: tool-${toolName}` with fields directly on the part.
// Our existing UI expects the v4-ish `toolInvocation` shape: { toolName, state, args, result }.

function isV5ToolPart(part: any): boolean {
  return !!part && typeof part.type === 'string' && part.type.startsWith('tool-');
}

function getToolNameFromV5Part(part: any): string {
  return String(part.type).replace(/^tool-/, '');
}

function mapV5StateToRendererState(state: unknown): string {
  if (typeof state !== 'string') return 'result';

  if (state === 'input-streaming') return 'partial-call';
  if (state === 'input-available') return 'call';
  if (state === 'output-available') return 'result';

  // Fallback: allow renderers to degrade to the default renderer's `result`.
  return 'result';
}

export function getToolCallFromPart(part: any): any | null {
  if (!part) return null;

  // v4-ish / persisted chats
  if (part.type === 'tool-invocation' && part.toolInvocation) {
    return part.toolInvocation;
  }

  // v5 UIMessage tool part
  if (isV5ToolPart(part)) {
    const toolName = getToolNameFromV5Part(part);
    const state = mapV5StateToRendererState(part.state);

    return {
      toolName,
      state,
      args: part.input,
      result: part.output,
      toolCallId: part.toolCallId,
      _raw: part,
    };
  }

  return null;
}

export function isToolPart(part: any): boolean {
  return !!getToolCallFromPart(part);
}
